import { el } from 'redom';
import Element from './Element';

export default class Icon extends Element {
  constructor(elementParent, attrs) {
    super(attrs);
    
    this.rootElement = el('i');

    if(attrs) {
      this.setAttrs(attrs);
    }

    if (elementParent) {
      elementParent.addChild(this);
    }
  }
}



// WEBPACK FOOTER //
// ./src/AAF/lib/gui/dom/Icon.js